<div cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
  <div cdkDragHandle class="drag-handle">
    <h2 mat-dialog-title class="headerCustomTitlePopup">
      {{"CALENDAR.POPUP.ADDEVENT" | translate}}
    </h2>
  </div>
</div>
<mat-dialog-content>
  <div [formGroup]="eventForm" class="row justify-content-center align-items-center p-sm-1">
    <div class="col-12 mt-2 mb- ps-0 pe-0 ps-sm-1 pe-sm-1 ps-md-2 pe-md-2">
      <div class="divider" style="color: var(--main-custom-blue) !important;">
        {{"CALENDAR.POPUP.TYPE" | translate}}
      </div>
      <div class="row justify-content-center align-items-center ps-1 pe-1 ps-md-2 pe-md-2 ps-lg-3 pe-lg-3 mt-1">
        <div class="col-12 ">

          <div class="btn-group" role="group">
            @for (type of listCalendarTypes; track type; let i = $index) {
              <input type="radio" class="btn-check" id="event_type{{i}}" autocomplete="off" formControlName="event_type"
                [value]="type.code">
              <label class="btn btn-outline-primary" for="event_type{{i}}">
                @if (!isSmall) {
                  <span>
                    {{type.title}}
                  </span>
                } @else {
                  {{type.title}}
                }
                @if (!isSmall && type.notes) {
                  <i class="bi bi-info-circle ms-2" [matTooltip]="type.notes">
                  </i>
                }
              </label>
            }
          </div>
        </div>
      </div>

      <div class="row justify-content-center mt-2">
        <div class="col-12">
          <div class="divider" style="color: var(--walley-brand) !important;">
            {{"CALENDAR.POPUP.GENERALINFO" | translate}}
          </div>
          <div class="row ps-1 pe-1 ps-md-2 pe-md-2 ps-lg-3 pe-lg-3">
            <!-- TITLE -->
            @if (eventForm.get('event_type')?.value != 'ROOM' && eventForm.get('event_type')?.value != 'COURSE') {
              <div
                class="col-12 col-md-8">
                <label class="form-label" for="title">
                  {{"CALENDAR.POPUP.TITLE" | translate}}
                </label>
                <input class="form-control" type="text" formControlName="title" id="title"
                  [class.is-invalid]="eventForm.get('title')?.invalid && submitted">
              </div>
            }

            <!-- ROOM -->
            @if (eventForm.get('event_type')?.value == 'ROOM') {
              <div class="col-12 col-md-8 col-lg-6">
                <label class="form-label" for="room">
                  {{"CALENDAR.POPUP.ROOM" | translate}}
                </label>
                <select class="form-select" id="room" formControlName="idroom">
                  <option [ngValue]="null">
                    --
                  </option>
                  @for (room of roomList; track room) {
                    <option [ngValue]="room.id">
                      {{room.name}}
                    </option>
                  }
                </select>
              </div>
            }

            <!-- COURSE -->
            @if (eventForm.get('event_type')?.value == 'COURSE') {
              <div class="col-12 col-md-8 col-lg-6">
                <label class="form-label" for="course">
                  {{"CALENDAR.POPUP.COURSE" | translate}}
                </label>
                <select class="form-select" id="course" formControlName="idcourse"
                  [class.is-invalid]="eventForm.get('idcourse')?.invalid && submitted">
                  <option [ngValue]="null">
                    --
                  </option>
                  @for (course of courseList; track course) {
                    <option [ngValue]="course.id">
                      {{course.name}}
                    </option>
                  }
                </select>
              </div>
            }

            <!-- DESCRIPTION -->
            <div class="col-12">
              <label class="form-label" for="description">
                {{"CALENDAR.POPUP.DESCRIPTION" | translate}}
              </label>
              <textarea class="form-control" formControlName="description" id="description"
                [class.is-invalid]="eventForm.get('description')?.invalid && submitted">
              </textarea>
            </div>

            <!-- INTERNAL -->
            <div class="col-12 mt-2">
              <div class="form-check form-check-inline mb-0">
                <input class="form-check-input" type="radio" id="external" formControlName="internal" [value]="0">
                <label class="form-check-label" for="external">
                  {{"CALENDAR.POPUP.EXTERNAL" | translate}}
                </label>
              </div>
              <div class="form-check form-check-inline mb-0">
                <input class="form-check-input" type="radio" id="internal" [value]="1" formControlName="internal">
                <label class="form-check-label" for="internal">
                  {{"CALENDAR.POPUP.INTERNAL" | translate}}
                </label>
              </div>
              <div class="form-check form-check-inline mb-0">
                <input class="form-check-input" type="radio" id="other" [value]="2" formControlName="internal">
                <label class="form-check-label" for="other">
                  {{"CALENDAR.POPUP.NOTSPECIFIED" | translate}}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- DATE BLOCK -->
      <div class="row justify-content-start mt-2">
        <div class="col-12">
          <div class="divider" style="color: var(--walley-brand) !important;">
            {{"CALENDAR.POPUP.SCHEDULEINFO" | translate}}
          </div>
          <div class="row ps-1 pe-1 ps-md-2 pe-md-2 ps-lg-3 pe-lg-3">

            <!-- IS ALL DAY -->
            <div class="col-12 mt-2">
              <div class="form-check mb-0">
                <input class="form-check-input" type="checkbox" id="isallday" formControlName="isallday">
                <label class="form-check-label" for="isallday">
                  {{"CALENDAR.POPUP.ALLDAY" | translate}}
                </label>
              </div>
            </div>

            <!-- START DATE -->
            <div class="col-6 col-sm-5 col-md-3">
              <label class="form-label" for="date_start">
                {{"CALENDAR.POPUP.STARTDATE" | translate}}
              </label>
              <input class="form-control" type="date" formControlName="date_start" id="date_start"
                [class.is-invalid]="eventForm.hasError('dateRangeInvalid') || (eventForm.get('date_start')?.invalid && submitted)">
            </div>

            <!-- END DATE -->
            <div class="col-6 col-sm-5 col-md-3">
              <label class="form-label" for="date_end">
                {{"CALENDAR.POPUP.ENDDATE" | translate}}
              </label>
              <input class="form-control" type="date" formControlName="date_end" id="date_end"
                [class.is-invalid]="eventForm.hasError('dateRangeInvalid') || (eventForm.get('date_end')?.invalid && submitted)">
            </div>

            <!-- START TIME -->
            <div class="col-6 col-sm-5 col-md-3">
              <label class="form-label" for="time_start">
                @if (!isSmall) {
                  <span>
                    {{"CALENDAR.POPUP.STARTTIME" | translate}}
                  </span>
                } @else {
                  {{"CALENDAR.POPUP.STARTTIMESM" | translate}}
                }
              </label>
              <input class="form-control ps-2 pe-2" type="time" formControlName="time_start" id="time_start"
                [class.is-invalid]="eventForm.get('time_start')?.invalid && submitted">
            </div>

            <!-- END TIME -->
            <div class="col-6 col-sm-5 col-md-3">
              <label class="form-label" for="time_end">
                @if (!isSmall) {
                  <span>
                    {{"CALENDAR.POPUP.ENDTIME" | translate}}
                  </span>
                } @else {
                  {{"CALENDAR.POPUP.ENDTIMESM" | translate}}
                }
              </label>
              <input class="form-control" type="time" formControlName="time_end" id="time_end"
                [class.is-invalid]="eventForm.get('time_end')?.invalid && submitted">
            </div>
          </div>
        </div>
      </div>

      <!-- INTERNAL BLOCK -->
      <div class="row justify-content-start mt-3">
        <div class="col-12">
          <div class="divider" style="color: var(--main-custom-blue) !important;">
            {{"CALENDAR.POPUP.RECIPIENT" | translate}}
          </div>

          <!-- INTERNAL == 0 -->
          @if (eventForm.get('internal')?.value == 0) {
            <div class="row ps-1 pe-1 ps-md-2 pe-md-2 ps-lg-3 pe-lg-3">
              <!-- CUSTOMER -->
              <div class="col-12 col-lg-4">
                <!-- AUTOCOMPLETE DENOMINAZIONE -->
                <label class="form-label" for="customer">{{"CUSTOMER.CUSTOMERLIST.DENOMINATION" |
                translate}}</label>
                <input type="text" [matAutocomplete]="customer" class="form-control" id="customer"
                  formControlName="customer" [class.is-invalid]="eventForm.get('customer')?.invalid"
                  [attr.aria-invalid]="eventForm.get('customer')?.invalid ? true : null">
                <mat-autocomplete #customer="matAutocomplete" [displayWith]="displayCustomerName">
                  @for (option of filteredCustomers$ | async; track option) {
                    <mat-option [value]="option">
                      <div>
                        {{option.denomination}}
                        @if (option.fiscalcode) {
                          <span>
                            -
                            {{option.fiscalcode}}
                          </span>
                        }
                        @if (option.vat) {
                          <span>
                            -
                            {{option.vat}}
                          </span>
                        }
                      </div>
                    </mat-option>
                  }
                </mat-autocomplete>
              </div>
              <!-- HEADQUARTER -->
              <div class="col-6 col-lg-4">
                <label class="form-label" for="customer_headquarter">
                  {{"CALENDAR.POPUP.HEADQUARTERCUSTOMER" | translate}}
                </label>
                <select class="form-select" id="customer_headquarter" formControlName="customer_headquarter">
                  <option [ngValue]="null">
                    --
                  </option>
                  @for (location of customerheadquarterList; track location) {
                    <option [ngValue]="location.idlocation">
                      {{location.street}} {{location.street_number}} {{location.city_it ? location.city_it.name :
                      location.city}}
                    </option>
                  }
                </select>
              </div>
              <!-- CONTACT -->
              @if (eventForm.get('event_type')?.value != 'COURSE') {
                <div class="col-6 col-lg-4">
                  <label class="form-label" for="contact">
                    {{"CALENDAR.POPUP.CONTACTCUSTOMER" | translate}}
                  </label>
                  <select class="form-select" id="contact" formControlName="idcontact">
                    <option [ngValue]="null">
                      --
                    </option>
                    @for (contact of contactList; track contact) {
                      <option [ngValue]="contact.id">
                        {{contact.name}}
                      </option>
                    }
                  </select>
                </div>
              }
              @if (eventForm.get('event_type')?.value == 'COURSE') {
                <div class="col-12 ">
                  <label class="form-label" for="customerstudents">
                    {{"CALENDAR.POPUP.CUSTOMERSTUDENTS" | translate}}
                  </label>
                  <mat-select class="form-control" id="customerstudents" formControlName="customerstudents" multiple>
                    <ng-container>
                      @for (student of studentsList; track student) {
                        <mat-option [value]="student.idstudent">
                          {{student.name}} {{student.surname}}
                        </mat-option>
                      }
                    </ng-container>
                  </mat-select>
                </div>
              }
            </div>
          }

          <!-- INTERNAL == 1 -->
          @if (eventForm.get('internal')?.value == 1) {
            <div class="row ps-1 pe-1 ps-md-2 pe-md-2 ps-lg-3 pe-lg-3">
              <!-- INTERNAL PERSON -->
              <!-- <div class="col-12 col-md-6">
              <label class="form-label" for="internal_person">
                {{"CALENDAR.POPUP.INTERNALPERSON" | translate}}
              </label>
              <input class="form-control" type="text" id="internal_person" formControlName="internal_person">
            </div> -->
            <!-- HEADQUARTER -->
            <div class="col-12 col-md-6">
              <label class="form-label" for="internal_headquarter">
                {{"CALENDAR.POPUP.HEADQUARTERINTERNAL" | translate}}
              </label>
              <select class="form-select" id="internal_headquarter" formControlName="internal_headquarter">
                <option [ngValue]="null">
                  --
                </option>
                @for (headquarter of headquarterList; track headquarter) {
                  <option [ngValue]="headquarter.id">
                    {{headquarter.address}} {{headquarter.house_number}} {{headquarter.municipality}}
                  </option>
                }
              </select>
            </div>
          </div>
        }

        <!-- INTERNAL == 2 -->
        <div class="row ps-1 pe-1 ps-md-2 pe-md-2 ps-lg-3 pe-lg-3">

          <!-- INTERNAL PERSON -->
          <div class="col-12 ">
            <label class="form-label" for="keepinformed">
              {{"CALENDAR.POPUP.INTERESTEDUSER" | translate}}
            </label>
            <mat-select class="form-control" id="keepinformed" formControlName="keepinformed" multiple
              [class.is-invalid]="eventForm.get('keepinformed')?.invalid && (eventForm.get('keepinformed')?.touched || submitted)">
              @if (usersList$ | async; as usersList) {
                @for (user of usersList; track user) {
                  <mat-option [value]="user.id">
                    {{user.nickname}} - {{user.email}}
                  </mat-option>
                }
              }
            </mat-select>

          </div>
        </div>
      </div>
    </div>

    <div class="row mt-2 errorTxt">
      @if (eventForm.get('customer')?.hasError('invalidCustomer')) {
        <div class="col-12 text-center">
          {{"CALENDAR.POPUP.CUSTOMERERROR" | translate}}
        </div>
      }
      @if (eventForm.hasError('dateRangeInvalid')) {
        <div class="col-12 text-center">
          {{"CALENDAR.POPUP.DATEERROR" | translate}}
        </div>
      }
      @if (eventForm.hasError('timeRangeInvalid')) {
        <div class="col-12 text-center">
          {{"CALENDAR.POPUP.TIMEERROR" | translate}}
        </div>
      }
      <ng-template #name>
        @if (submitted && eventForm.invalid) {
          <div class="col-12">
            <span>
              {{"CALENDAR.POPUP.MISSINGFIELDS" | translate}}
            </span><br>
          </div>
        }
      </ng-template>

    </div>
  </div>
</div>
</mat-dialog-content>

<mat-dialog-actions style="border-top: 1px solid lightgray;" class="d-flex justify-content-between">
  <button class="btn btn-outline-primary ms-2" (click)="close()">
    {{"CALENDAR.POPUP.CLOSE" | translate }}
  </button>
  <button class="btn btn-outline-success me-2" (click)="save()">
    {{"CALENDAR.POPUP.SAVE" | translate }}
  </button>
</mat-dialog-actions>
